import React from "react";
import CreateProductModal from "../../modals/CreateProduct/CreateProductModal";
import styles from "./variableProductPage.module.css";

export default function ServiceOverview({ product, onSave }) {
    const [editing, setEditing] = React.useState(false);
    const [saved, setSaved] = React.useState(false);

    return (
        <section className={styles.details} aria-label="Service overview">
            <div className={styles.heading}>
                <h1>{product.name}</h1>
                <button type="button" className={styles.secondaryButton} onClick={() => {
                    setSaved(false);
                    setEditing(true);
                }}>Edit details</button>
            </div>
            <p className={styles.description}>{product.description || "No description added."}</p>
            <div className={styles.metrics}>
                <div>
                    <h4 className={styles.metricLabel}>Base price:</h4>
                    <p>${(Number(product.base_price ?? product.BasePrice ?? 0) / 100).toFixed(2)}</p>
                </div>
                <div>
                    <h4 className={styles.metricLabel}>Base duration:</h4>
                    <p>{product.base_duration ?? product.BaseDuration ?? 0} minutes</p>
                </div>
            </div>
            {saved && <p role="status" className={styles.helper}>Service details saved.</p>}
            {editing && <CreateProductModal
                isOpen
                isEditing
                initialProduct={product}
                onClose={() => setEditing(false)}
                onSaveChanges={async (details) => {
                    await onSave(details);
                    setSaved(true);
                }}
            />}
        </section>
    );
}
